import { render } from "./DropdownItem.vue?vue&type=template&id=95b1b11c&scoped=true"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

import "./DropdownItem.vue?vue&type=style&index=0&id=95b1b11c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b1b11c"]])

export default __exports__